import UserCenter from './UserCenter.vue';
import PtAvatar from './Avatar';

UserCenter.PtAvatar = PtAvatar;
export default UserCenter;
